import {
    requestMethodTypes,
    requestHeaderNames,
    requestHeaderValue,
} from '../Constants/api.constants';

const userActionsRequest = (
    requestData = {}
) => {
    const {
        AUTHORIZATION,
        CONTENT_TYPE,
    } = requestHeaderNames;
    const {
        CONTENT_TYPE_JSON,
        BEARER,
    } = requestHeaderValue;

    const method = requestMethodTypes.GET;
    const headers = {
        [CONTENT_TYPE]: CONTENT_TYPE_JSON,
        [AUTHORIZATION]: `${BEARER} ${requestData.token}`,
    };

    const request = {
        method,
        headers,
    };

    return request;
};

export default userActionsRequest;
